import { render, staticRenderFns } from "./BienDetails.vue?vue&type=template&id=bddec04c"
import script from "./BienDetails.vue?vue&type=script&lang=js"
export * from "./BienDetails.vue?vue&type=script&lang=js"
import style0 from "./BienDetails.vue?vue&type=style&index=0&id=bddec04c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports